import * as yup from 'yup';
import _ from "lodash"

yup.setLocale({
    mixed: {
        required: 'Required field',
    }
});

yup.addMethod(yup.array, "uniqueBy", function (message, mapPath, isCaseSensitive) {
    return this.test("uniqueBy", message, function (list) {
        const map = {};
        const foundIndex = _.findIndex(list, (item) => {
            let property = _.get(item, mapPath);

            if (isCaseSensitive) {
                property = (property || "").toLowerCase();
            }

            if (!map[property]) {
                map[property] = true
            } else {
                return true
            }
        })

        if (foundIndex > 0) {
            return this.createError({path: `${this.path}[${foundIndex}].${mapPath}`, message});
        } else {
            return true
        }
    });
});

yup.addMethod(yup.object, "fileType", function (message, extension) {
    return this.test("fileType", message, function (file) {
        if (!file || file.fileName?.endsWith(extension)) {
            return true
        } else {
            this.createError({path: `${this.path}`, message});
        }
    });
});

yup.addMethod(yup.object, "fileSize", function (message, maxSizeInBytes) {
    return this.test("fileSize", message, function (file) {
        if (!file || file.contents?.length <= maxSizeInBytes) {
            return true
        } else {
            this.createError({path: `${this.path}`, message});
        }
    });
});